import { supabase } from "../supabase";

export interface Member {
  id: string;
  display_name: string;
}

/**
 * 同じカップルの二人ぶんの表示名。
 *
 * RLS の `profiles_select` が「同じ couple_id の全員」を返すため、
 * 絞り込まずに引けば相手ぶんも含めて取れる。
 */
export async function fetchMembers(): Promise<Map<string, string>> {
  const { data, error } = await supabase.from("profiles").select("id, display_name");
  if (error) throw error;
  const rows: Member[] = data;
  return new Map(rows.map((row) => [row.id, row.display_name]));
}
